module.exports = __webpack_public_path__ + "img/his-generic.895a0cab.svg";